export default __webpack_public_path__ + "static/media/Andrew-Robl.85ab4dfd.png";